<div [formGroup]="parentForm">
  <clr-select-container>
    <label [ngStyle]="{ 'font-size.px': fontSize }">Лікар:</label>
    <select [ngStyle]="{ 'font-size.px': fontSize }" clrSelect name="options" [formControlName]="'doctors'">
      <option *ngFor="let doctor of doctors"
        [value]="doctor">{{ doctor }}</option>
    </select>
  </clr-select-container>
</div>
